export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 300 300"
    enableBackground="new 0 0 300 300"
    xmlSpace="preserve"
  >
    <path d="M290.8 272.4c7.8-7.8 11.4-22.8 7.9-33.3l-1.5-4.5c-3.5-10.5-15.1-21.5-25.8-24.4L232 199.5c-10.7-2.9-25.9 1-33.8 8.8 l-14.3 14.3c-51.8-14-92.5-54.7-106.5-106.5l14.3-14.3c7.8-7.8 11.7-23 8.8-33.7L89.8 28.6C86.9 18 75.9 6.4 65.4 2.9l-4.5-1.5 c-10.5-3.5-25.5 0-33.3 7.9L6.3 30.6C2.5 34.4 0 45.2 0 45.3c-0.7 67.7 25.8 133 73.7 180.9c47.8 47.8 112.8 74.3 180.4 73.8 c0.4 0 11.5-2.4 15.3-6.2" />
  </svg>
);
